export const WORKFLOW_FORM_NAME = 'workflowCreate';
export const WORKFLOW_UPDATE_FORM = 'workflowUpdate';
export const DEFAULT_WORKFLOW = 'default';
export const STATUS_PATH = '_status';
export const STEP_COLOR_PALETTE = ['#7e7b84', '#FFC107', '#442AB9', '#F25F5C', '#5CD79B'];
